import Head from "next/head";
import MatterportLandingPage from "../../../components/MatterportLandingPage";

const LandingPageMatterport = () => {
    return (
        <>
            <Head>
                <title>Matterport - Fotop Serviços</title>
                <meta name="viewport" content="initial-scale=1.0,width=device-width" />
                <link rel="stylesheet" type="text/css" href="/css/outside.css" />
            </Head>

            <MatterportLandingPage />
        </>
    );
};

export default LandingPageMatterport;
